<template>
  <div class="switcher" :class="{ 'max-lg:flex': showBottomSheet }">
    <button
      v-click-outside="closeDropdown"
      class="dropdown-toggle uppercase"
      aria-label="toggle dropdown"
      :style="navTextColorStyle"
      @click="toggleDropdown"
    >
      {{ activeItem }}
      <icon-chevron-black v-if="!showBottomSheet" class="mx-3" />
    </button>
    <template v-if="!showBottomSheet">
      <div v-if="isOpen" class="dropdown-menu mt-3">
        <div
          v-for="item in list"
          :key="item.code"
          class="menu-item"
          :class="{
            active: item.code === activeItem,
            'lg:!text-center': isCentered,
          }"
          @click="changeActiveItem(item.code)"
        >
          {{ `${showCode ? item.code + " | " : ""}` + item.name }}
          <icon-check />
        </div>
      </div>
    </template>
    <BaseBottomSheet v-else v-model:show="isOpen" fitHeight>
      <div class="dropdown-menu mb-3 px-7">
        <div
          v-for="item in list"
          :key="item.code"
          class="cursor-pointer flex gap-2 items-center my-2"
          :class="{
            'lg:!text-center': isCentered,
            'cursor-pointer text-left text-nowrap text-paragraph-color lg:text-primary-1 opacity-70 text-heading-6 hover:lg:bg-gray-4;':
              item.code !== activeItem,
          }"
          @click="changeActiveItem(item.code)"
        >
          {{ `${showCode ? item.code + " | " : ""}` + item.name }}
          <icon-check v-if="item.code === activeItem" />
        </div>
      </div>
    </BaseBottomSheet>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import type { PropType } from "vue";

interface DropdownData {
  name: string;
  code: string;
  id: number;
}

const emit = defineEmits(["update:activeItem"]);
const localePath = useLocalePath();
const props = defineProps({
  list: { type: Array as PropType<DropdownData[] | any[]>, required: true },
  isCentered: { type: Boolean, default: false },
  showCode: { type: Boolean, default: true },
  activeItem: { type: String, default: "" },
  routePath: { type: String, default: "/" },
  showBottomSheet: { type: Boolean, default: false },
  headerData: {
    type: Object,
    default: () => {
      return {};
    },
  },
  isScrolled: { type: Boolean, default: false },
});
const navTextColorStyle = computed(() => {
  return props.headerData?.navTextColor && !props.isScrolled
    ? { color: `var(--${props.headerData.navTextColor})` }
    : undefined;
});

const isDesktop = ref(false);
const handleResize = () => {
  isDesktop.value = window.innerWidth >= 1024;
};
onMounted(() => {
  handleResize();
});
const isOpen = ref(false);
const changeActiveItem = (code) => {
  emit("update:activeItem", code);
};
const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};
const closeDropdown = () => {
  isOpen.value = false;
};
</script>
